import { useState } from 'react'
import { QUERY_GET_MERCHANT, useShopClient } from 'shop/client'
import { mapStoreSettingsIntoObject } from '../useGlobalContext/helpers'
import { Store } from 'shop/components/Landing/types'
import { useShop } from '../useGlobalContext'

export const useMerchant = () => {
  const client = useShopClient()
  const { config } = useShop()
  const [merchant, setMerchant] = useState<any | undefined>() // No Type for the Hasura Merchant :'(
  const [allStores, setAllStores] = useState<Store[]>([])
  const [hasRecentlyFetchedMerchant, setHasRecentlyFetchedMerchant] =
    useState(false)
  const [isMerchantLoading, setIsMerchantLoading] = useState<boolean>(false)

  const refetchMerchantAndStores = () => {
    if (hasRecentlyFetchedMerchant) return
    setIsMerchantLoading(true)
    setHasRecentlyFetchedMerchant(true)
    client
      .query({
        query: QUERY_GET_MERCHANT,
        variables: { slug: config.domain },
        fetchPolicy: 'network-only'
      })
      .then((result) => {
        const [merchant] = result?.data?.merchants
        let stores = result?.data?.stores

        if (!!stores.length) stores = mapStoreSettingsIntoObject(stores)

        setMerchant(merchant)
        setAllStores(stores)
        setTimeout(() => {
          setHasRecentlyFetchedMerchant(false)
        }, 10000) // 10 secs
      })
      .finally(() => setIsMerchantLoading(false))
  }

  return {
    merchant,
    setMerchant,
    allStores,
    refetchMerchantAndStores,
    isMerchantLoading
  }
}
